module.exports = __webpack_public_path__ + "img/symbol_5.2be0fae1.png";